import styles from "@shared/components/chat/Messages.module.scss"

import React, { memo } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import { useLayerPopupContext, useMessagesContext } from "@shared/contexts"
import { useMessagesRef } from "@shared/hooks"

import classNames from "classnames"

interface Props {
  isActive: boolean
  isUser?: boolean
}

export default memo(function ManagerMessages({ isActive }: Props) {
  const { font } = useLayerPopupContext()
  const { managerMessages: messages } = useMessagesContext()

  const { messagesRef, handleScroll: scrollMessages } = useMessagesRef({ messages })

  return (
    <div
      className={classNames(
        "chatB",
        [isActive ? styles.active : styles.hidden],
        styles.chatBoxExpand,
      )}
    >
      <div
        ref={messagesRef}
        className={classNames("inner", styles[font.size])}
      >
        {messages.map((message) => (
          <PowerfulMessage key={message.key} message={message} scrollMessages={scrollMessages} />
        ))}
        <ChatDownIcon messagesRef={messagesRef} />
      </div>
    </div>
  )
})
